export default {
  rentList: [ 
  ],
  rentFilter: {
    filter_style: "all",
    filter_campus: {},
    filter_blocks: {}
  },
  rentSearchQuery: "",
  canRefine: false,
  rezAreaList: []
};
